import { render, staticRenderFns } from "./PushNotificationsAndInstall.vue?vue&type=template&id=312e1693&scoped=true"
import script from "./PushNotificationsAndInstall.vue?vue&type=script&lang=js"
export * from "./PushNotificationsAndInstall.vue?vue&type=script&lang=js"
import style0 from "./PushNotificationsAndInstall.vue?vue&type=style&index=0&id=312e1693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312e1693",
  null
  
)

export default component.exports